(async () => {
    const { 
        loadScript,
        loadStyle
    } = await import(window.theme.modules.utils);

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('video-player', class extends baseComponent.default {
        elements = {
            player: '[data-player]',
            HTMLPlayer: 'video'
        }

        connectedCallback() {
            if (super.connectedCallback) super.connectedCallback();
            // NSG speed fix 2: load the video file only when the customer interacts with it
            this._loadSource = this._loadSource.bind(this);
            ['pointerdown', 'touchstart', 'keydown', 'click'].forEach((type) => {
                this.addEventListener(type, this._loadSource, { capture: true, passive: true });
            });
        }

        _loadSource() {
            if (this._sourceLoaded) return;
            const video = this.querySelector('video');
            if (!video) return;
            const sources = video.querySelectorAll('source[data-src]');
            if (!sources.length) { this._sourceLoaded = true; return; }
            sources.forEach((source) => {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
            });
            video.setAttribute('preload', 'auto');
            video.load();
            this._sourceLoaded = true;
        }

        async onIntersect(isIntersecting) {
            if(isIntersecting && !this.player) {
                await this._initPlayer();
            }
            if(!isIntersecting && this.player && this.player.playing) {
                this.player.pause();
            }
        }

        async _initPlayer() {
            loadStyle('https://cdn.plyr.io/3.6.8/plyr.css');
            if(!window.Plyr) {
                await loadScript(window.theme.scripts.Plyr);
            }
            this.player = new window.Plyr(this.hasAttribute('internal') ? this.$HTMLPlayer : this.$player);
        }
    })
})();